// A decorative sculpture of the recorded equity sequence. The readable chart
// remains separate: perspective must never become the only way to read returns.
export function landscapeValues(points, count = 96) {
  const values = (points || []).map(point => Number(point.value)).filter(Number.isFinite);
  if (!values.length) values.push(0);
  const low = Math.min(0, ...values), high = Math.max(0, ...values), span = Math.max(high - low, 1);
  return Array.from({ length: count }, (_, index) => {
    const at = index / Math.max(count - 1, 1) * (values.length - 1);
    const before = Math.floor(at), after = Math.min(values.length - 1, before + 1);
    return ((values[before] + (values[after] - values[before]) * (at - before)) - low) / span;
  });
}

export function projectLandscape(x, y, z, yaw, width, height) {
  const rx = x * Math.cos(yaw) - z * Math.sin(yaw);
  const rz = x * Math.sin(yaw) + z * Math.cos(yaw);
  const tilt = .46, ry = y * Math.cos(tilt) - rz * Math.sin(tilt);
  const depth = y * Math.sin(tilt) + rz * Math.cos(tilt);
  const scale = Math.min(width / 3.65, height / 3.0) * 3.8 / (3.8 + depth);
  return [width * .52 + rx * scale, height * .58 - ry * scale];
}
